// formats price in cents
function formatPrice(price) {
  return (price / 100).toLocaleString('de', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
  });
}

function formatPriceWithLeadingZeros(price, size) {
  let s = price + "";
  while (s.length < size) s = "0" + s;
  return s;
}

const COOKIES_KEY = 'cookiesEnabled';

function cookiesEnabled() {
  try {
    const value = window.localStorage.getItem(COOKIES_KEY);
    return value == null ? false : JSON.parse(value) === true;
  } catch (e) {
    return false;
  }

}

function setCookiesEnabled(value) {
  window.localStorage.setItem(COOKIES_KEY, JSON.stringify(value));
}

// remaping of special chars
const specialCharsMap = {
  č: 'c',
  ć: 'c',
  š: 's',
  ž: 'z',
  đ: 'dz',
};

// normalization to ignore special chars
function normalizeString(term) {
  let ret = '';
  for (let i = 0; i < term.length; i++) {
    ret += specialCharsMap[term.charAt(i)] || term.charAt(i);
  }
  return ret;
}

function copyToClipboard(s) {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(s);
  } else if (window.clipboardData) {  // IE
    window.clipboardData.setData('text', s);
  } else {  // other browsers, iOS, Mac OS
    throw DOMException('Could not copy.');
  }
}

function generateQRCodeString(obj, sep) {
  let ret = "";
  let count = 0;
  for (const el in obj) {
    ret += obj[el] + sep;
    count += obj[el].length + 2;
    // plus 2 for new line characters
  }
  return `${ret}${count}\n`;
}

export {
  formatPrice,
  formatPriceWithLeadingZeros,
  cookiesEnabled,
  normalizeString,
  setCookiesEnabled,
  copyToClipboard,
  generateQRCodeString,
};